import { Component, Inject, OnInit, OnDestroy } from "@angular/core";
import { FormControl, ReactiveFormsModule } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { TokenService } from "@assoanalytics/app/core/services/token.service";
import { MaterialModule } from "@assoanalytics/app/material.module";
import { TranslateModule } from "@ngx-translate/core";
import { provideTablerIcons, TablerIconComponent } from "angular-tabler-icons";
import { IconAlertTriangle, IconKey } from "angular-tabler-icons/icons";
import { CookieService } from "ngx-cookie-service";

@Component({
  selector: "app-password-change-suggest-modal",
  templateUrl: "./password-change-suggest-modal.component.html",
  styleUrl: "./password-change-suggest-modal.component.scss",
  imports: [
    TranslateModule,
    MaterialModule,
    TablerIconComponent,
    ReactiveFormsModule,
  ],
  providers: [
    CookieService,
    provideTablerIcons({ IconAlertTriangle, IconKey }),
  ],
})
export class PasswordChangeSuggestModalComponent implements OnInit, OnDestroy {
  dontShowAgainControl = new FormControl(false);
  private dontShowAgainSub: any;
  expiringInto: number | null = null;

  constructor(
    private tokenService: TokenService,
    private router: Router,
    private dialogRef: MatDialogRef<PasswordChangeSuggestModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private cookieService: CookieService,
  ) {
    if (data && data.expiringInto) {
      this.expiringInto = data.expiringInto;
    }
  }

  ngOnInit() {
    this.dontShowAgainSub = this.dontShowAgainControl.valueChanges.subscribe(
      (checked: boolean | null) => {
        const cookieName = "password_expiration_suggestion";
        if (checked === true) {
          const tokenData = this.tokenService.getTokenData();
          if (tokenData && tokenData.iat) {
            const iat =
              typeof tokenData.iat === "string"
                ? parseInt(tokenData.iat, 10)
                : tokenData.iat;
            const expires = new Date(iat * 1000);
            expires.setMonth(expires.getMonth() + 1);
            this.cookieService.set(cookieName, "1", { expires, path: "/" });
          } else {
            const expires = new Date();
            expires.setMonth(expires.getMonth() + 1);
            this.cookieService.set(cookieName, "1", { expires, path: "/" });
          }
        } else {
          this.cookieService.delete(cookieName, "/");
        }
      },
    );
  }

  ngOnDestroy() {
    if (this.dontShowAgainSub) {
      this.dontShowAgainSub.unsubscribe();
    }
  }

  close() {
    this.router.navigate(["/dashboard"]);
    this.dialogRef.close();
  }

  goToPasswordChange() {
    this.dialogRef.close();
    this.router.navigate(["/anagrafica/modifica-password"]);
  }

  goToMfaConfig() {
    this.router.navigate(["/anagrafica/configura-mfa"]);
    this.dialogRef.close();
  }
}
